import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import Translate from '../lang/Translate';
import { dismissPasswordExpiredWarning } from '../../actions/auth';

const PasswordExpiredWarningModal = ({
  isOpen,
  passwordExpiredWarning,
  dismissPasswordExpiredWarning,
}) => {
  const handleClose = () => {
    dismissPasswordExpiredWarning();
  };

  const handleGoToChangePassword = () => {
    dismissPasswordExpiredWarning();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose} centered>
      <ModalHeader toggle={handleClose}>
        <i className="fas fa-exclamation-triangle text-warning mr-2" />
        <Translate msg="PASSWORD_EXPIRED_WARNING_TITLE" />
      </ModalHeader>
      <ModalBody>
        <p className="mb-0">
          <Translate msg="PASSWORD_EXPIRED_WARNING_ADMIN" />
        </p>
      </ModalBody>
      <ModalFooter>
        <Link to="/change_pw" className="btn btn-primary" onClick={handleGoToChangePassword}>
          <Translate msg="CHANGE_PW" />
        </Link>
        <Button color="secondary" onClick={handleClose}>
          <Translate msg="CLOSE" />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

PasswordExpiredWarningModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  passwordExpiredWarning: PropTypes.bool,
  dismissPasswordExpiredWarning: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  passwordExpiredWarning: state.auth.passwordExpiredWarning,
});

export default connect(mapStateToProps, { dismissPasswordExpiredWarning })(PasswordExpiredWarningModal);
